const getTemporaryState = (key) => (state) => state.temporaryState[key];
export default getTemporaryState;
